import React, { Component } from "react";
import Profile from "../components/profile";
import Breonna from "../profiles/Breonna.jpg"
import Jim from "../profiles/jim.jpg";
import "./membersMobile.css";
import Kathy from "../profiles/kathy.jpg"
import Abisai from "../profiles/Abisai Perez-Gomez 2026.jpg"

class member3 extends Component {
  render() {
    return (
      <div
        className="parentContainerMembersMobile"
        style={{
          height: this.props.height - 50 + "px",
          postion: "relative",
          bottom: "0px",
        }}
      >
        <h1 className="pageTitleMobile">Board Members</h1>

        <Profile
        Name={"Kathy Cluck"}
          Description={"Honorary Board Member"}
          Image={Kathy}
          width={"50%"}
          height={"25%"}>
        </Profile>
     
        <Profile
          Name={"Jim Honeyford"}
          Description={"Honorary Board Member"}
          Image={Jim}
          width={"50%"}
          height={"25%"}
        ></Profile>
        <Profile
          Name={"Breonna Latham"}
          Description={"Board Advisor"}
          Image={Breonna}
          width={"50%"}
          height={"25%"}
        ></Profile>
        <Profile
          Name={"Abisai Perez-Gomez"}
          Description={"Student Board Representative"}
          Image={Abisai}
          width={"50%"}
          height={"25%"}
        ></Profile>
      </div>
    );
  }
}

export default member3;
